export enum AccountType {
  MAIN = 'MAIN',
  COMFORT = 'COMFORT',
}

type AccountTypeRecord = Record<AccountType, string>;

export const AccountTypeMapped: AccountTypeRecord = {
  [AccountType.MAIN]: 'Основной',
  [AccountType.COMFORT]: 'Комфорт',
};

export const translateAccountType = (type: AccountType): string => {
  return AccountTypeMapped[type];
};
